import React, { useState, useEffect } from "react";
import PaymentService from "../../services/paymentService";

export const CustomPayment = () => {
  const [products, setProducts] = useState<any[]>();

  useEffect(() => {
    getProducts();
  }, []);

  //Post verify
  const getProducts = async () => {
    const response = await PaymentService.getProducts();
    setProducts(response.data);
  };
  return (
    <div>
      {products &&
        products.map((product: any) => {
          return <p>{product.productName}</p>;
        })}
      <h1>ahmet</h1>
    </div>
  );
};
